import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../../../_components/common/Navbar';
import Footer from '../../../_components/common/Footer';
import { Link } from 'react-router-dom';

class LOIReport extends Component {
    constructor(props) {
        super(props);

    }
    state = {
        is_info_open: false,
        options: [
            {
                id: 0,
                name: 'Completely False'
            },
            {
                id: 1,
                name: 'To A Very Great Extent False'
            },
            {
                id: 2,
                name: 'To A Great Extent False'
            },
            {
                id: 3,
                name: 'To Some Extent False'
            },
            {
                id: 4,
                name: 'Neither True nor False'
            },
            {
                id: 5,
                name: 'To Some Extent True'
            },
            {
                id: 6,
                name: 'To A Great Extent True'
            },
            {
                id: 7,
                name: 'To A Very Great Extent True'
            },
            {
                id: 8,
                name: 'Completely True'
            },
        ],

    }






    LOIAssessmentRenderer() {


        return (
            <div className="container custom-container my-5" >
                <div>
                    <h1>
                        Q2
                    </h1>
                    <p>
                        I avoid expressing my feelings, emotions, and thoughts in my relationships.
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <i className="fas fa-info" style={{ padding: '10px' }} onClick={() => this.setState({ is_info_open: !this.state.is_info_open })}></i>
                        {
                            this.state.is_info_open ? <p>hello world</p> : null
                        }
                    </div>
                    {
                        this.state.options.map((obj, key) =>
                            <div style={{ display: 'flex', flexDirection: 'column', height: 150, flex: key == 0 || key == (this.state.options.length - 1) ? 1.5 : 1 }}>
                                <div style={{ flex: .9, alignItems: 'center', borderWidth: 1, borderTopWidth: 0, borderStyle: 'solid' }}>
                                    <p style={{ textAlign: 'center' }}>{obj.name}</p>
                                </div>
                                <div style={{ flex: .1, backgroundColor: '#e1e1e1', borderWidth: 1, borderTopWidth: 0, borderStyle: 'solid' }}>

                                </div>
                            </div>
                        )
                    }
                    <div style={{ textAlign: 'center' }}>
                        <Link to=''>
                            <button
                                className={
                                    "btn btn-red btn-sm text-uppercase"
                                }
                                style={{ margin: '2px', fontSize: '16px', paddingTop: 10, paddingBottom: 10 }}
                            >
                                Next
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (!this.props.error) {
            return (
                <div>
                    <NavBar />
                    {this.LOIAssessmentRenderer()}
                    <Footer />
                </div>
            );
        } else {
            return (

                <h1>Something went wrong</h1>
            );
        }

    }

}

function mapStateToProps(state) {




    return {

    };
}

export default connect(mapStateToProps)(LOIReport);


// WEBPACK FOOTER //
// ./src/_pages/DashBoard/LOI/loiAssessment.js